<template>
  <div class="form-group">
    <div class="item-name">
      <label>電話番号</label>
      <div v-if="$v.telephoneNumber.$dirty">
        <div class="error-text" v-if="!$v.telephoneNumber.required">
          電話番号を入力してください。
        </div>
      </div>
    </div>
    <input
      class="telephone-number"
      :class="status($v.telephoneNumber)"
      type="number"
      v-model="$v.telephoneNumber.$model"
      placeholder="09012345678"
      @change="changeTelephoneNumber"
    />
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      telephoneNumber: ""
    };
  },
  validations: {
    telephoneNumber: {
      required
    }
  },
  methods: {
    status(validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      };
    },
    changeTelephoneNumber(e) {
      const val = e.target.value
      this.telephoneNumber = val
      this.$emit('handle-change-telephoneNumber', this.telephoneNumber)
    }
  }
};
</script>

<style>
.telephone-number {
  width: 200px;
  height: 30px;
  border-style: hidden;
  border-bottom: solid 1px;
  margin: 0 10px 0 10px;
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/molecules/InputTelephoneNumber.vue